import { create } from 'zustand';

import AppConfig from '../config/AppConfig';
import BackEndConnection from '../dal/BackEndConnection';

const SubjectMatterCategoryStore = create((set) => ({
    subjectMatterCategorys: null,
    subjectMatterCategory: null,
    currentPage: 1,
    pageSize: 9,

    updateAttribute: (attributeName, newValue) => {
        set((state) => {
            state.subjectMatterCategory[attributeName] = newValue;
            return { subjectMatterCategory: state.subjectMatterCategory };
        });
    },

    resetSubjectMatterCategory: () => {
        set((state) => {
            return { subjectMatterCategory: {} };
        });
    },

    loadAll: (pageSize, currentPage, successCallback, errorCallback) => {
        const payload = { pageSize: pageSize, currentPage: currentPage };
        const url = AppConfig.HOST_URL + 'subjectMatterCategory/loadAll';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({
                    subjectMatterCategorys: data.results,
                    bears: state.bears + 2,
                }));
            },
            successCallback,
            errorCallback,
        );
    },

    load: (id, successCallback, errorCallback) => {
        const payload = { id: id };
        const url = AppConfig.HOST_URL + 'subjectMatterCategory/load';

        return BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ subjectMatterCategory: data }));
            },
            successCallback,
            errorCallback,
        );
    },

    create: (data, successCallback, errorCallback) => {
        const payload = { jsonStr: JSON.stringify(data) };
        var url = AppConfig.HOST_URL + 'subjectMatterCategory/create';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    update: (data, successCallback, errorCallback) => {
        const payload = { jsonStr: JSON.stringify(data) };
        var url = AppConfig.HOST_URL + 'subjectMatterCategory/update';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    delete: (id, successCallback, errorCallback) => {
        const payload = { id: id };
        var url = AppConfig.HOST_URL + 'subjectMatterCategory/delete';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },
}));

export default SubjectMatterCategoryStore;
